import { config } from 'lib-shared-backend-config';
import { HTTPRequestMethod } from 'lib-shared-legacy-types';
import { ajaxSend, ApiBasePath } from 'api/api';
const base = '/v1/wait_music';
export function getAllMusic() {
    return ajaxSend({
        path: `${base}`,
    });
}
export function uploadFile(payload) {
    if (!payload) {
        console.error('upload - No valid payload given.');
        return Promise.reject();
    }
    if (payload.file === undefined) {
        console.error('upload file - No valid file in payload given.');
        return Promise.reject();
    }
    const data = new FormData();
    data.append('file', payload.file);
    return ajaxSend({
        path: `/private/attachment`,
        method: HTTPRequestMethod.Post,
        basePath: ApiBasePath.Files,
        headers: {
            contentType: 'multipart/form-data',
        },
        data,
    }).then((response) => {
        var _a;
        if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.relative_uri) {
            response.data.absolute_uri = `${config.url.files}${response.data.relative_uri}`;
            return response;
        }
        return response;
    });
}
export function musicSplit(payload) {
    return ajaxSend({
        method: HTTPRequestMethod.Post,
        path: `${base}`,
        data: {
            name: payload.name,
            master_file_path: payload.masterFilePath,
        },
    });
}
